import React from "react";

const TableHeader = ({ headers, sortConfig, onSort, headerClassName, tableStyle }) => {
  return (
    <thead>
      <tr>
        {headers.map(({ key, label, sortable }) => (
          <th
            key={key}
            className={`py-2 px-4 font-normal text-gray-400 text-left border-b border-gray-200 ${headerClassName} ${
              sortable ? "cursor-pointer hover:underline" : ""
            }`}
            onClick={sortable ? () => onSort(key) : undefined}
            aria-sort={
              sortConfig.key === key ? sortConfig.direction : undefined
            }
            style={tableStyle} // Apply tableStyle to th
          >
            {label}{" "}
            {sortConfig.key === key
              ? sortConfig.direction === "asc"
                ? "↑"
                : "↓"
              : ""}
          </th>
        ))}
        <th
          className={`py-2 px-4 font-normal pr-10 text-gray-400 text-right border-b border-gray-200 w-24 ${headerClassName}`}
          style={tableStyle} // Apply tableStyle to th
        >
          Action
        </th>
      </tr>
    </thead>
  );
};

export default TableHeader;